var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 45 40" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { fill: "#FF6262", fillRule: "nonzero", d: "M22.5 0a5.2 5.2 0 0 0-4.53 2.64l-16.39 29a5.58 5.58 0 0 0 .05 5.58A5.63 5.63 0 0 0 6.5 40H38.5a5.63 5.63 0 0 0 4.86-2.77 5.58 5.58 0 0 0 .05-5.58l-16.39-29A5.2 5.2 0 0 0 22.5 0z" }),
      React.createElement("path", { fill: "#FFF", d: "M24.43 24.14c-.03-.47-.03-.64-.03-.85 0-.31.02-.76.05-1.53l.34-6.15c.07-1.04.12-1.85.21-2.61h-4c.07.6.15 1.65.2 2.62l.35 6.14c.07 1.16.07 1.16.07 1.37 0 .45 0 .56-.04 1h2.85zm.31 6.36v-3.66H21.3v3.66h3.45z" })
    )
  );
});